import { TranslateLoader, TranslateService  } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { Inject } from '@angular/core';
import { InjectionToken } from '@angular/core';

export const I18N_PATH = new InjectionToken<string>('I18N_PATH');
export const I18N_LANGUAGES = new InjectionToken<string>('I18N_LANGUAGES');

export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    @Inject(I18N_PATH) private path: string

  ) {  }

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.path}${lang}.json`);
  }
}

export function initTranslations(translate: TranslateService, languages: string[]) {
  return () => {

    const defaultLang = languages[0];

    translate.addLangs(languages);
    translate.setDefaultLang(defaultLang);

    let browserLang = translate.getBrowserLang();
    browserLang = browserLang=='en' 
      ? 'uk'
      : browserLang;

    const lang = browserLang && languages.includes(browserLang)
      ? browserLang
      : defaultLang;

    return firstValueFrom(translate.use(lang));
  };
}

